import { render, staticRenderFns } from "./playerReportCard.vue?vue&type=template&id=1c4dbd44&scoped=true"
import script from "./playerReportCard.vue?vue&type=script&lang=js"
export * from "./playerReportCard.vue?vue&type=script&lang=js"
import style0 from "./playerReportCard.vue?vue&type=style&index=0&id=1c4dbd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4dbd44",
  null
  
)

export default component.exports